import { createSlice } from '@reduxjs/toolkit';
import { fetchLiftSupport } from '../actions/liftSupport.action';

const initialState = {
  liftSupport: {
    isLoading: false,
    isNeedReloadData: true,
    data: {},
  },
};

export const liftSupportReducer = createSlice({
  name: 'LiftSupport',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchLiftSupport.pending, state => {
        state.liftSupport = {
          ...state.liftSupport,
          isLoading: true,
          isNeedReloadData: false,
        };
      })
      .addCase(fetchLiftSupport.fulfilled, (state, action) => {
        console.log(action.payload?.data);
        state.liftSupport = {
          ...state.liftSupport,
          isLoading: false,
          data: action.payload?.data || {},
        };
      })
      .addCase(fetchLiftSupport.rejected, (state, action) => {
        state.liftSupport = {
          ...state.liftSupport,
          isLoading: false,
        };
      });
  },
});

export default liftSupportReducer.reducer;
